import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  LinearProgress,
  Typography,
  Box,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import Pagination from "@mui/material/Pagination";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  acceptedClusterByVendor,
  fetchIndividualClusterPayment,
} from "../../../redux/slices/vendorPaymentSlice";
import styles from "../Scrollarea.module.css";

const PaymentTable = () => {
  // for pagination
  const [page, setPage] = useState(0); // starts from 0
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchProduct, setSearchProduct] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const pageSizeOptions = [1, 5, 10, 50, 100, 200];

  const dispatch = useDispatch();
  const { vendorId } = useSelector((state) => state.vendorAuth);
  const {
    clustersAcceptedByVendor,
    individualClusterPaymentData,
    loading,
    totalClustersCount,
  } = useSelector((state) => state.vendorPayment);
  const totalPages = Math.ceil(totalClustersCount / rowsPerPage);

  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const formatCurrency = (amount) => {
    return `₹${amount.toLocaleString("en-IN")}`;
  };

  const getStatusColor = (status) => {
    return status === "Paid" ? "success" : "warning";
  };

  const formatDateShort = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handlePaginationChange = (newPage, newLimit = rowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newLimit);
    // dispatch(fetchClusters({ vendorId, page: newPage + 1, limit: newLimit }));
  };

  const handleChangePage = (event, newPage) => {
    handlePaginationChange(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    handlePaginationChange(0, newLimit);
  };

  const handleStatusChange = (event) => {
    console.log("eveb", event.target.value);
    setPaymentStatus(event.target.value);
  };
  console.log("payment status", paymentStatus);

  useEffect(() => {
    if (vendorId) {
      dispatch(
        acceptedClusterByVendor({
          vendorId,
          page: page + 1, // backend expects 1-based indexing
          limit: rowsPerPage,
          searchProduct,
          paymentStatus,
        })
      );
    }
  }, [vendorId, page, rowsPerPage, dispatch, paymentStatus, searchProduct]);

  return (
    <div className="px-2 sticky top-0 z-10">
      {/* Header */}
      <div className=" py-4 flex justify-between pr-4">
        <h1 className="text-2xl font-semibold text-black">Salary Credit</h1>
        <div className=" flex justify-center items-center">
          <h1 className="text-2xl font-semibold text-black">
            Total: {totalClustersCount}
          </h1>
        </div>
      </div>

      {/* Table */}
      <TableContainer
        component={Paper}
        className={`${styles.scrollContainer} overflow-auto`}
        sx={{ height: "calc(90vh - 120px)" }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 2, // higher than filter row
                backgroundColor: "#f1f5f9",
              }}
              className="bg-gray-50 "
            >
              <TableCell>
                <span className="font-semibold text-sm">PRODUCT NAME</span>
              </TableCell>
              <TableCell>
                <span className=" font-semibold text-sm">TIMELINE</span>
              </TableCell>
              <TableCell>
                <span className=" font-semibold text-sm">BUDGET</span>
              </TableCell>
              <TableCell>
                <span className=" font-semibold text-sm">AMOUNT RECEIVED</span>
              </TableCell>
              <TableCell>
                <span className=" font-semibold text-sm">QUANTITY</span>
              </TableCell>
              <TableCell>
                <span className=" font-semibold text-sm">WORK COMPLETION</span>
              </TableCell>
              <TableCell>
                <span className=" font-semibold text-sm">PAYMENT STATUS</span>
              </TableCell>
              <TableCell>
                <span className="font-semibold text-sm">ACTION</span>
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                position: "sticky",
                top: 57, // height of first header row
                zIndex: 1,
                backgroundColor: "white",
              }}
              className="bg-white z-20"
            >
              <TableCell>
                <input
                  type="text"
                  placeholder="Search product"
                  className="w-full text-sm px-3 py-2 border border-gray-300 rounded-md bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={searchProduct}
                  onChange={(e) => {
                    setSearchProduct(e.target.value);
                    setPage(0); // optional: reset to first page on search
                  }}
                />
              </TableCell>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="status-select-label">Status</InputLabel>
                  <Select
                    labelId="status-select-label"
                    id="status-select"
                    value={paymentStatus}
                    onChange={(e) => handleStatusChange(e)}
                    label="Status"
                  >
                    <MenuItem value="">
                      <em>All</em>
                    </MenuItem>
                    <MenuItem value="paid">Paid</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>{/* Empty for action */}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clustersAcceptedByVendor.length > 0 ? (
              clustersAcceptedByVendor.map((row) => (
                <TableRow key={row._id} className="hover:bg-gray-50">
                  <TableCell className="text-gray-600 text-sm">
                    {row?.productType}
                  </TableCell>
                  <TableCell className="text-gray-600 text-sm">
                    {formatDateShort(row?.jobStartingDate)} -{" "}
                    {formatDateShort(row?.jobCompletionDate)}
                  </TableCell>
                  <TableCell className="text-gray-600 text-sm font-medium">
                    {formatCurrency(row?.paymentAmount)}
                  </TableCell>
                  <TableCell align="center">
                    <span className="font-medium">
                      {formatCurrency(row?.totalAmountPaidTillNow)}
                    </span>
                  </TableCell>
                  <TableCell className="text-gray-600 text-sm">
                    {row?.totalNumberOfJobs}
                  </TableCell>
                  <TableCell className="min-w-[120px]">
                    <Box className="flex items-center gap-2">
                      <LinearProgress
                        variant="determinate"
                        value={row?.workCompletedByVendor}
                        className="flex-1 h-2 rounded-full"
                        sx={{
                          backgroundColor: "#e5e7eb",
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: "#3b82f6",
                            borderRadius: "4px",
                          },
                        }}
                      />
                      <Typography
                        variant="caption"
                        className="text-gray-600 min-w-[35px]"
                      >
                        {Math.floor(row?.workCompletedByVendor)}%
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    {(() => {
                      const label =
                        row?.paymentAmount === row?.totalAmountPaidTillNow
                          ? "Paid"
                          : "Pending";
                      return (
                        <Chip
                          label={label}
                          size="small"
                          className="font-medium"
                          sx={{
                            backgroundColor:
                              label === "Paid" ? "#05CD9933" : "#FFD6001A",
                            color: label === "Paid" ? "#05CD99" : "#FFD600",
                            "& .MuiChip-label": {
                              fontSize: "0.75rem",
                              px: 2,
                              width: "100px",
                              fontWeight: 500,
                              textAlign: "center",
                            },
                          }}
                        />
                      );
                    })()}
                  </TableCell>
                  <TableCell>
                    <button
                      onClick={() => {
                        setSelectedRow(row);
                        setOpenModal(true);
                        dispatch(
                          fetchIndividualClusterPayment({
                            vendorId,
                            clusterId: row?._id,
                          })
                        );
                      }}
                      className="text-blue-600 hover:text-blue-800 text-sm font-medium hover:underline"
                    >
                      View
                    </button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents: "none", // so it doesn't block interactions
                }}
              >
                <TableCell
                  colSpan={8}
                  align="center"
                  className="text-gray-500 text-sm"
                  sx={{ border: "none" }}
                >
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="flex items-center justify-between my-2">
        <FormControl variant="standard" size="small" sx={{ minWidth: 80 }}>
          <InputLabel id="page-size-label">Rows</InputLabel>
          <Select
            labelId="page-size-label"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            label="Rows"
          >
            {pageSizeOptions.map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Pagination
          className="p-2 flex justify-center"
          count={totalPages}
          page={page + 1} // Pagination is 1-based
          onChange={(event, value) => handleChangePage(event, value - 1)}
          sx={{
            "& .MuiPaginationItem-root.Mui-selected": {
              backgroundColor: "#418cff",
              color: "#fff",
            },
            "& .MuiPaginationItem-root.Mui-selected:hover": {
              backgroundColor: "#3366cc",
            },
            "& .MuiPaginationItem-root": {
              "&:hover": {
                backgroundColor: "#ddd",
              },
            },
          }}
        />
      </div>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            maxHeight: "90vh",
          }}
        >
          <button
            onClick={() => setOpenModal(false)}
            className="absolute -top-2 -right-3 text-gray-500 bg-white px-2 border py-0.5 rounded-full hover:text-gray-700"
          >
            ✕
          </button>
          {selectedRow && (
            <div className="max-w-lg mx-auto bg-gray-50">
              {/* Header Card */}
              <div
                className="rounded-2xl p-4 text-white mb-6"
                style={{
                  backgroundImage:
                    "url('/assests/vendorPortalImages/paymentCard2.webp')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="flex items-center justify-between mb-4">
                  <h1 className="text-base text-white w-48 font-medium uppercase">
                    {selectedRow?.productType}
                  </h1>
                  <span className="bg-gray-600 px-3 py-1 rounded-full text-sm">
                    {`${selectedRow?.totalNumberOfJobs}  Nos`}
                  </span>
                </div>

                <div className="mb-4">
                  <div className="flex items-baseline gap-2 mb-2">
                    <span className="text-3xl font-bold text-green-400">
                      ₹
                      {selectedRow?.totalAmountPaidTillNow.toLocaleString(
                        "en-IN"
                      )}
                    </span>
                    <span>
                      / {selectedRow?.paymentAmount.toLocaleString("en-IN")}
                    </span>
                    <span className="text-gray-400 ml-auto">
                      {`${Math.round(
                        (selectedRow?.totalAmountPaidTillNow /
                          selectedRow?.paymentAmount) *
                          100
                      )}%`}
                    </span>
                  </div>

                  {/* Progress Bar */}
                  <div className="w-full bg-gray-700 rounded-full h-1.5 mb-4">
                    <div
                      className="bg-blue-500 h-1.5 rounded-full"
                      style={{
                        width: `${
                          (selectedRow?.totalAmountPaidTillNow /
                            selectedRow?.paymentAmount) *
                          100
                        }%`,
                      }}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center">
                      <span className="text-xs">👤</span>
                    </div>
                    <span className="text-sm">Abhimanyu Chauhan</span>
                  </div>
                  <div className="text-gray-400 flex flex-col text-sm">
                    <span>{formatDateShort(selectedRow?.jobStartingDate)}</span>
                    <span className=" w-full flex justify-center">| </span>
                    <span>
                      {formatDateShort(selectedRow?.jobCompletionDate)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Transaction List */}
              <div
                className={`${styles.scrollContainerForTransaction} space-y-6 h-[200px] overflow-y-auto`}
              >
                {/* First Transaction */}
                {loading ? (
                  <div className="text-gray-500 flex justify-center items-center h-full w-full py-4">
                    <CircularProgress />
                  </div>
                ) : individualClusterPaymentData.length === 0 ? (
                  <div className="text-gray-500 h-full flex items-center justify-center text-center py-4">
                    No transaction data
                  </div>
                ) : (
                  individualClusterPaymentData.map((transaction, index) => (
                    <div key={index} className="flex items-start gap-4 mx-2">
                      <div className="flex-1 bg-white rounded-lg p-2 shadow-sm">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-2xl font-bold text-green-500">
                            ₹{transaction?.amountPaid.toLocaleString("en-IN")}
                          </span>
                          <span className="bg-[#6694F0] text-white px-3 py-1 rounded-full text-sm font-medium">
                            {transaction?.paymentMethod}
                          </span>
                        </div>
                        <div className="flex items-center justify-between text-sm text-gray-500">
                          <span>{`UTR : ${transaction?.transactionId}`}</span>
                          <span>
                            {new Date(
                              transaction?.paymentDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* View Dashboard Button */}
              <div className="mt-8">
                <button
                  onClick={() => navigate("/vendorportal/jobs/cluster")}
                  className="w-full bg-white border-2 border-blue-300 text-blue-500 py-2 rounded-xl font-medium text-lg hover:bg-blue-50 transition-colors"
                >
                  View Dashboard
                </button>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default PaymentTable;
